export enum VoidReasonRouteEnum {
  MAIN = "void-reasons.main",
}
